import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from 'reducers';

import refreshMiddleware from './../middlewares/refreshMiddleware';
import timeoutMiddleware from './../middlewares/timeoutMiddleware';
import sentryReduxMiddleware from './../utils/sentryReduxMiddleware';

const persistConfig = {
  key: 'root',
  whitelist: ['auth', 'user', 'youthAthlete'],
  storage,
};

const enhancer = compose(
  applyMiddleware(
    createDebounce(),
    refreshMiddleware,
    timeoutMiddleware,
    sentryReduxMiddleware,
    thunk,
  ),
);

export default function configureStore(initialState) {
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const store = createStore(persistedReducer, initialState, enhancer);
  const persistor = persistStore(store);
  return { store, persistor };
}
